import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    container: {
        marginBottom: '3rem',
    },
    title: {
        fontSize: '16px',
        fontWeight: 400,
        marginTop: '2.5rem',
        marginBottom: '1.5rem',
    },
    listItem: {
        marginTop: '25px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '14px',
    },
    avatar: {
        width: '40px!important',
        height: '40px!important',
        borderRadius: '50%',
        objectFit: 'cover',
    },
    nameAndLocationContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    name: {
        fontSize: '18px',
        fontWeight: 600,
    },
    city: {
        marginLeft: '10px',
        color: theme.palette.secondary.main,
        display: 'flex',
        fontWeight: 500,
        marginTop: '4px',
        fontSize: '1rem',
    },
}));
